import './globals.coffee'
import './prototypes.coffee'

import i18n from './i18n'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VeeValidate, { Validator } from 'vee-validate'
import VueInfiniteScroll from 'vue-infinite-scroll'
import VueMask from 'v-mask'
import Autocomplete from 'v-autocomplete'
import VueVirtualScroller from 'vue-virtual-scroller'
import routes from './routes.coffee'
import ui from './libraries/ui.coffee'
import global_mixin from './global_mixin.coffee'
import { store } from './store/store.js'

Validator.updateDictionary({
  'pt-BR': {
    messages: Locales.error_messages,
    attributes: Locales.attributes,
  }
})

Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VeeValidate, { strict: false, delay: 0, locale: 'pt-BR' })
Vue.use(VueInfiniteScroll)
Vue.use(VueMask)
Vue.use(Autocomplete)
Vue.use(VueVirtualScroller)

Vue.mixin(global_mixin)

const router = new VueRouter({
  mode: 'history',
  routes: routes.routes
})

router.beforeEach(routes.guards.email)

new Vue({
  el: '#app-wrapper',
  components: {
    globalLoader: require('./views/shared/global_loader.vue')
  },
  i18n,
  store: store,
  router: router,
  template: `<div>
              <global-loader></global-loader>
              <router-view></router-view>
            </div>`
})



// WEBPACK FOOTER //
// ./src/main.js